import type { ServerBasePrice } from "services/types";
import type { CandleWithFlag } from "../model/types";

interface ApplyLineTickParams {
  dataRef: React.MutableRefObject<(ServerBasePrice | CandleWithFlag)[]>;
  timeframeMs: number;
  price: number;
  timestamp: number;
  animatedPriceRef: React.MutableRefObject<number | null>;
  animationStartTimeRef: React.MutableRefObject<number>;
  liveLinePriceRef: React.MutableRefObject<number | null>;
}

export function applyLineTick({
  dataRef,
  timeframeMs,
  price,
  timestamp,
  animatedPriceRef,
  animationStartTimeRef,
  liveLinePriceRef,
}: ApplyLineTickParams) {
  const lineData = dataRef.current as ServerBasePrice[];
  if (!lineData.length) return;

  const last = lineData[lineData.length - 1];
  const lastBucket = Math.floor(Date.parse(last.timestamp) / timeframeMs) * timeframeMs;
  const bucket = Math.floor(timestamp / timeframeMs) * timeframeMs;

  animatedPriceRef.current = last.price;
  animationStartTimeRef.current = performance.now();
  liveLinePriceRef.current = price;

  if (bucket === lastBucket) {
    last.price = price;
  }
  if (bucket > lastBucket) {
    lineData.push({ timestamp: new Date(bucket).toISOString(), price });
  }
}
